import React, { useEffect, useState, useRef } from 'react';
import { Grid, Typography, Link, CircularProgress } from '@mui/material';
import CustomTooltip from '../components/customTooltip';
import KeyboardAltOutlinedIcon from '@mui/icons-material/KeyboardAltOutlined';
import SaveIcon from '@mui/icons-material/Save';
import { FaShare, FaFolderOpen, FaCopy } from 'react-icons/fa';
import { BsFillFileEarmarkTextFill } from 'react-icons/bs';
import { FaVideo } from 'react-icons/fa';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ModalCustom from '../components/modalCustom';
import ModalLoad from '../components/modalLoad';
import WarningModal from '../components/warningModal';
import VideoModal from '../components/videoModal';
import RightSection from '../right-section/right-section';
import HttpService from '../../services/http.service';
import RoundButton from '../components/roundButton';
import '../assets/css/middle-section.css';
import parkerPreview from '../cad/generateCAD';
import CAD from '../cad/cad';
import {
  generateCADXMLforManifold,
  getCADUrl,
  getMidentProjectName,
  isValidPartNumber
} from '../../services/cadService';

import {
  uniqueCodeTemplate,
  getUniquePartIdentifierforManifold,
  create
} from '../../services/bomService';

import { getPartNumberString } from '../../services/tactonService';

import {
  cancelConfigurationDataLayer,
  supportDocumentDataLayer
} from '../../services/pdfDataLayer';

import PartNumberComponent from '../components/partNumberComponent';

import {
  refreshProp65,
  refreshSupportDocuments,
  refreshProductDescription
} from '../../services/productService';

import { postSessionData } from '../../services/sessionDataService';

import { getContentSyndicationData } from '../../services/contentSyndicationService';

import { getPossibleImages } from '../../services/imageSourceService';

const MiddleSection = props => {
  const [openModal, setOpenModal] = React.useState(false);
  const [openWarnigModal, setOpenWarningModal] = React.useState(false);
  const [modalValue, setModalValue] = React.useState({});
  const handleOpen = () => setOpenModal(true);
  const [modalLoadValue, setLoadModalValue] = React.useState({});
  const [openLoadModal, setLoadOpenModal] = React.useState(false);
  const [productDiscription, setProductDiscription] = React.useState();
  const [techSpecification, setTechSpecification] = React.useState();
  const [supportDocs, setSupportDocs] = React.useState();
  const handleLoadOpen = () => setLoadOpenModal(true);
  //const previousPartNumber = useRef(null);
  const [imageUrl, setImageUrl] = useState();
  const [possibleImages, setPossibleImages] = useState([]);
  const [baseUrl, setBaseUrl] = useState();
  const [mident, setMident] = useState();
  const [partSolutionsAPI, setPartSolutionsAPI] = useState();

  const [copyValue, setCopyValue] = useState({
    text: '',
    copy: false
  });
  let copyPartNumber = '';
  let series = '';
  const {
    dataItems,
    sessionDataItems,
    handleCopyToClipBoard,
    handleSearchPartNumber,
    savedPartNumber,
    lang,
    passCadUrlToParent,
    uniquePartIdentifier,
    handleUniquePartNumber,
    priceLeadTime,
    hoseAssemblyPrice,
    activeTab,
    handleSetCommits,
    commits,
    handleIsCADValueChanged,
    isCADValueChanged
  } = props;
  const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);
  const breakpoint = 620;
  const [width, setWidth] = useState(window.innerWidth);
  const [cadURL, setCadURL] = useState('');
  const [cadOverlay, setCadOverlay] = useState(false);
  const [cadOverlayLoader, setCadOverlayLoader] = useState(false);
  const [catalog, setCatalog] = useState();
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [prop65, setProp65] = useState();
  const [bomItems, setBomItems] = useState();
  const [cadPartNumber, setCadPartNumber] = useState('');
  const [previousCadPartNumber, setPreviousCadPartNumber] = useState('');
  const [cadPartNumberLoaded, setCadPartNumberLoaded] = useState(false);
  const [currentPartNumber, setCurrentPartNumber] = useState('');
  const [previousPartNumber, setPreviousPartNumber] = useState('');
  const [cadDetails, setCadDetails] = useState();
  const [isValidCad, setIsValidCad] = useState(true);

  let localUniquePartIdentifier = uniquePartIdentifier;

  var members = [];
  var groupMem = [];
  var secondarycomp = [];

  useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener('resize', () => setWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, []);

  const handleClose = async name => {
    setOpenModal(false);
    props.isLoading(false);
    setModalValue({});
    if (name)
      cancelConfigurationDataLayer(
        sessionDataItems,
        getPartNumberString(dataItems),
        name
      );
  };
  const handleLoadClose = async (loadDataLayer, name) => {
    setLoadOpenModal(false);
    setLoadModalValue({});

    if (loadDataLayer)
      cancelConfigurationDataLayer(
        sessionDataItems,
        getPartNumberString(dataItems),
        name
      );
  };

  const sethandleOpen = (heading, button, placeholder, value, submit, eMsg) => {
    setModalValue({
      heading: heading,
      button: button,
      placeholder: placeholder,
      value: value,
      submitType: submit,
      errorMsg: eMsg
    });
    handleOpen();
  };
  const sethandleLoadOpen = (
    heading,
    button,
    deleteButton,
    cancelButton,
    placeholder,
    value,
    submit,
    eMsg
  ) => {
    setLoadModalValue({
      heading: heading,
      button: button,
      deleteButton: deleteButton,
      cancelButton: cancelButton,
      placeholder: placeholder,
      value: value,
      configModel: sessionDataItems?.configModel,
      submitType: submit,
      errorMsg: eMsg
    });
    handleLoadOpen();
  };

  useEffect(() => {
    async function load() {
      await loadCad(false);
    }
    load();
  }, []);

  useEffect(async () => {
    var partNumber = '';
    if (dataItems?.isNormalProduct || dataItems?.isManifoldProduct) {
      partNumber = dataItems?.infoGroup?.cadCode?.value;
      if (partNumber == '') {
        partNumber = getPartNumberString(dataItems);
      }
    } else {
      partNumber = dataItems?.infoGroup?.orderCodeComplete?.value;
    }

    console.log('CAD PART:' + partNumber);

    if (!dataItems?.isManifoldProduct) {
      setCadPartNumber(dataItems?.infoGroup?.cadCode?.value);
    } else {
      setCadPartNumber(getPartNumberString(dataItems));
    }

    if (partNumber == currentPartNumber) return;

    if (dataItems?.tactonModel?.steps[0].name == 'product_selection') {
      let currentSeries = '';
      var currentStep = getCurrentStep();
      if (currentStep[0].name == 'product_selection')
        currentSeries = sessionDataItems?.configModel;
      else currentSeries = currentStep[0].description;

      if (series == '' || series != currentSeries) {
        setBaseUrl(await getBaseUrl(currentSeries));
        series = currentSeries;
      }
    }

    if (!currentPartNumber) {
      setCurrentPartNumber(partNumber);
      setPreviousPartNumber(partNumber);
      await generateCadSrc();
    } else {
      setCurrentPartNumber(partNumber);
    }

    if (baseUrl?.source == 'ImageGrid') await loadImageGrid();

    setIsValidCad(true);
  }, [dataItems?.tactonModel?.configState]);

  useEffect(async () => {
    if (baseUrl?.source == 'ImageGrid') await loadImageGrid();
  }, [baseUrl]);

  const generateCadSrc = async () => {
    if (dataItems?.isManifoldProduct) {
      var midentProjectName = await getMidentProjectName(
        sessionDataItems.configModel
      );
      var assemblyCADXML = await generateCADXMLforManifold(
        dataItems,
        sessionDataItems
      );

      let cadDetails = await getCADUrl(
        sessionDataItems?.manufacturingLocation,
        ''
      );

      setPartSolutionsAPI(cadDetails?.misc);

      setBomItems(getBomItems(assemblyCADXML));
      setMident(
        '{ATYP=ASSISTANT},{APP=PartAssembly},{COMPANY=parker},{DATA=script=us_configurator/parker/v1/asmscripts/' +
          midentProjectName +
          '.vbb&xml=' +
          encodeURIComponent(assemblyCADXML) +
          '}'
      );
      setCadPartNumberLoaded(true);
      setCadPartNumber(getPartNumberString(dataItems));
    } else {
      let cadCode = dataItems?.infoGroup?.cadCode?.value;

      setCadPartNumber(cadCode);
      setPreviousCadPartNumber(cadCode);

      if (cadCode) {
        let cadDetails = await getCADUrl(
          sessionDataItems?.manufacturingLocation,
          cadCode
        );

        setCadURL(cadDetails.baseUrl);
        setCatalog(cadDetails.catalog);
        passCadUrlToParent(cadDetails.baseUrl);
        setPartSolutionsAPI(cadDetails.misc);
        let mident = await parkerPreview.GenerateMident(
          cadCode,
          cadDetails.catalog,
          cadDetails.misc
        );
        setMident(mident);
        setCadPartNumberLoaded(true);
      }
    }
  };

  useEffect(() => {
    if (sessionDataItems) {
      let lanP = sessionDataItems?.language;
      getProductTechSpec(
        sessionDataItems.storeId,
        sessionDataItems.productId,
        lanP
      );
      getSupportDoc(
        sessionDataItems.productId,
        sessionDataItems?.countryId,
        lanP
      );
      getProp65(sessionDataItems?.configModel, lanP);
    }
  }, [props.sessionDataItems]);

  const getCurrentStep = () => {
    return dataItems?.tactonModel?.steps?.filter(x => x.current);
  };

  const getBaseUrl = async seriesName => {
    let baseUrlData;
    await HttpService.getById(
      '/Cad',
      '?DivisionId=' +
        sessionDataItems?.manufacturingLocation +
        '&configModel=' +
        seriesName
    )
      .then(res => {
        baseUrlData = res.data;
      })
      .catch(error => {
        props.isLoading(false);
      });
    return baseUrlData;
  };

  const loadCad = async () => {
    series = sessionDataItems?.configModel;
    let baseUrlData = await getBaseUrl(series);
    setBaseUrl(baseUrlData);
    setPreviousPartNumber(currentPartNumber);
    await generateCadSrc();
  };

  const isCADVisible = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication?.cad_visible;
  };

  const showPartSection = () => {
    let currentStep = getCurrentStep();
    if (!currentStep || currentStep.length == 0) return false;

    if (currentStep[0].name == 'product_selection') return false;
    else return true;
  };

  const isPartnumberActions = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication.partnumberactions_visible;
  };

  const isPartNumberVisible = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems.contentSyndication.partnumber_visible;
  };

  const loadImageGrid = async () => {
    let currentStep = getCurrentStep();
    if (!currentStep) return false;

    var rootGroup = currentStep[0].rootGroup;
    var tempMem;
    var infoGroup = [];
    members = [];
    var filterMembers = rootGroup.members.filter(x =>
      x.name.includes('ui_group')
    );
    if (filterMembers.length == 0) {
      infoGroup = rootGroup.members.filter(
        x => x.properties && x.properties['info_group'] == 'yes'
      );
      filterMembers = rootGroup.members.filter(x => !infoGroup.includes(x));
      for (var i = 0; i < filterMembers.length; i++) {
        tempMem = filterMembers[i].members;
        addmember(tempMem);
      }
      while (groupMem.length > 0) {
        tempMem = groupMem;
        groupMem = [];
        for (var k = 0; k < tempMem.length; k++) {
          addmember(tempMem[k].members);
        }
      }
    } else {
      members = filterMembers[0].members;
    }
    var inputModel = [];
    var imageinput;
    setPossibleImages([]);

    for (var i = 0; i < members.length; i++) {
      if (members[i].imageSequence != null && members[i].imageSequence > 0) {
        imageinput = {};
        imageinput.ManufacturingDivision =
          sessionDataItems?.manufacturingDivision;
        imageinput.ConfigModel = sessionDataItems?.configModel;
        imageinput.ComponentName = members[i].value;
        imageinput.ImageSequence = members[i].imageSequence;
        for (var j = 0; j < secondarycomp.length; j++) {
          if (
            secondarycomp[j].imageSequence == members[i].imageSequence ||
            (secondarycomp[j].imageSequence == 0 &&
              members[i].imageSequence != 2)
          ) {
            imageinput.SecComponentName = secondarycomp[j].value;
          }
        }
        inputModel.push(imageinput);
      }
    }

    let possibleImages = await getPossibleImages(inputModel);
    setPossibleImages(possibleImages);
  };

  const addmember = tempMem => {
    var singleComp;
    for (var j = 0; j < tempMem.length; j++) {
      if (tempMem[j].isGroup == false) {
        if (tempMem[j].properties['hidden'] == 'no') {
          if (
            tempMem[j].properties != undefined &&
            tempMem[j].properties['ph_image_sequence'] != undefined &&
            tempMem[j].properties['ph_image_sequence'] != ''
          ) {
            tempMem[j].imageSequence =
              tempMem[j].properties['ph_image_sequence'];
          } else if (
            tempMem[j].properties != undefined &&
            tempMem[j].properties['ph_image_sequence_connect'] != undefined &&
            tempMem[j].properties['ph_image_sequence_connect'] != ''
          ) {
            singleComp = {};
            singleComp.value = tempMem[j].value;
            if (tempMem[j].properties['ph_image_sequence_connect'] == 'yes')
              singleComp.imageSequence = 0;
            else
              singleComp.imageSequence =
                tempMem[j].properties['ph_image_sequence_connect'];
            secondarycomp.push(singleComp);
          }
          members = members.concat(tempMem[j]);
        }
      } else {
        groupMem = groupMem.concat(tempMem[j]);
      }
    }
  };

  // const GetPossibleImages = async inputModel => {
  //   let possibleImages;
  //   await HttpService.postByObject('/ImageSource/GetPossibleImages', inputModel)
  //     .then(res => {
  //       possibleImages = res.data;
  //     })
  //     .catch(error => {
  //       props.isLoading(false);
  //     });
  //   return possibleImages;
  // };

  const isProductDesc = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication?.productdescription_visible;
  };

  const isTechnicalSpec = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication?.technicalspecification_visible;
  };

  const hasProp65Message = () => {
    return (
      (sessionDataItems?.countryId || '').toLowerCase() == '687pdc' &&
      prop65 &&
      prop65.length > 0
    );
  };

  const isProp65 = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication?.prop65warning_visible;
  };

  const hasSafetyWarning = () => {
    return (sessionDataItems?.language || '').toLowerCase() == 'en';
  };
  const isnotShop = () => {
    return (
      sessionDataItems?.option != '100' && sessionDataItems?.option != '101'
    );
  };

  const isSafetyWarn = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication?.safetywarning_visible;
  };

  const isSupportDoc = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication?.supportdocuments_visible;
  };

  const gotoPage = async documentInfo => {
    supportDocumentDataLayer(documentInfo, sessionDataItems);
    if (
      documentInfo.urlKeyword_s !== '' &&
      documentInfo.urlKeyword_s !== undefined
    ) {
      window.open(documentInfo.urlKeyword_s, '_blank');
    }
  };
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  const handleToolTipForCopyToClipboard = async () => {
    setTooltipIsOpen(true);
    await sleep(1500);
    setTooltipIsOpen(false);
  };

  const getProductTechSpec = async (storeId, productId, language) => {
    let productInfo = await refreshProductDescription(
      storeId,
      productId,
      language
    );
    setProductDiscription(productInfo?.description);
    setTechSpecification(productInfo?.specifications);

    // //console.log('product spec language code', language);
    // if (storeId == undefined) {
    //   storeId = '10151';
    // }
    // await HttpService.getAll(
    //   `Product/${storeId}/${productId}/${language}`
    // ).then(res => {
    //   if (res.data != undefined) {
    //     setProductDiscription(res.data?.description);
    //     setTechSpecification(res.data?.specifications);
    //     //console.log('Product ID', productId);
    //     //console.log('Store ID', storeId);
    //     //console.log('Product Description', res.data?.description);
    //     //console.log('Product Specification', res.data?.specifications);
    //   } else {
    //     console.log('no data found');
    //   }
    // });
  };

  const getSupportDoc = async (productId, countryId, language) => {
    var supportDocuments = await refreshSupportDocuments(
      productId,
      countryId,
      language
    );
    setSupportDocs(supportDocuments);
    // await HttpService.getAll(
    //   `SupportDocuments/${productId}/${countryId}/${language}`
    // )
    //   .then(res => {
    //     if (res.data != undefined) {
    //       setSupportDocs(res.data);
    //     } else {
    //       console.log('no data found');
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  };

  const getProp65 = async (configModel, language) => {
    var prop65Message = await refreshProp65(configModel, language);
    setProp65(prop65Message);
  };

  const getUniquePartNumber = () => {
    if (!uniquePartIdentifier) {
      if (dataItems?.isManifoldProduct)
        return 'Please save the configuration to generate 2P Part Number';
      else return 'Please save the configuration to generate Unique ID';
    } else {
      return uniquePartIdentifier;
    }

    // if (store.UniquePartIdentifier == "" ||  store.isValueChanged)
    // {
    //   store.UniquePartIdentifier="";
    // if (!uniquePartIdentifier)
    //   return 'Please save the configuration to generate 2P Part Number';
    // else return uniquePartIdentifier;
    // }
    // else{
    //   return store.UniquePartIdentifier;
    // }
  };

  const handleCopyPartNumber = async () => {
    setCopyValue({
      text: '',
      copy: false
    });
    let partNumber;
    var uniqueCode = uniqueCodeTemplate(dataItems);
    if (uniqueCode) {
      let uniquePartNumner = await getUniquePartIdentifierforManifold(
        dataItems,
        sessionDataItems
      );
      partNumber = uniquePartNumner;
      handleUniquePartNumber(uniquePartNumner);
      localUniquePartIdentifier = uniquePartNumner;
    } else if (!dataItems?.isNormalProduct) {
      partNumber = dataItems?.infoGroup?.orderCodeComplete?.value;
    } else {
      partNumber = getPartNumberString(dataItems);
    }
    await navigator.clipboard.writeText(partNumber);
    await handleCopyToClipBoard(partNumber, localUniquePartIdentifier);
    handleToolTipForCopyToClipboard();
    setCopyValue({
      text: partNumber,
      copy: true
    });
  };

  const isUniqueCodeAvailable = () => {
    var uniqueCode = uniqueCodeTemplate(dataItems);
    if (uniqueCode == '') return false;
    else return true;
  };

  const handleSaveRequest = async () => {
    var title = '';
    let uniquePartNumner = '';
    var uniqueCode = uniqueCodeTemplate(dataItems);
    if (uniqueCode) {
      uniquePartNumner = await getUniquePartIdentifierforManifold(
        dataItems,
        sessionDataItems
      );
      title = uniquePartNumner;
      if (dataItems.isManifoldProduct)
        sessionDataItems.partNumber = uniquePartNumner;
      else sessionDataItems.partNumber = getPartNumberString(dataItems);
      handleUniquePartNumber(uniquePartNumner);
    } else if (!dataItems?.isNormalProduct) {
      sessionDataItems.partNumber =
        dataItems?.infoGroup?.orderCodeComplete?.value;
      title = dataItems?.infoGroup?.orderCodeComplete?.value;
    } else {
      sessionDataItems.partNumber = getPartNumberString(dataItems);
      title = getPartNumberString(dataItems);
    }

    //Create a new SessionId

    sessionDataItems.bomRefId = null;

    var sessionId = await postSessionData(sessionDataItems);

    await create(
      dataItems,
      sessionDataItems,
      sessionId,
      sessionDataItems.partNumber,
      uniquePartNumner
    );

    sethandleOpen(
      lang?.SAVE_CONFIGURATION,
      lang?.SAVE,
      lang?.ENTER_CONFIG_NAME,
      `${title} - `,
      'save',
      { isError: false, message: '' }
    );
  };

  const handleSupportModalClick = document => {
    setShowVideoModal(true);
    setVideoUrl(document?.urlKeyword_s);
  };

  const updatePreview = async () => {
    try {
      props.isLoading(true);
      if (sessionDataItems.contentSyndication != null) {
        var configdata = getContentSyndicationData(
          sessionDataItems,
          dataItems,
          uniquePartIdentifier
        );
        console.log(configdata);
        window.parent.postMessage(
          {
            econfigdata: configdata
          },
          '*'
        );
      }

      if (commits && commits.length > 0) {
        let category = '',
          position = '';
        let allCommits = commits.split('|');
        allCommits.forEach(item => {
          let commit = item.split('!');
          if (commit.length > 0) {
            if (category) category += ', ' + commit[0];
            else category = commit[0];
          }
          if (commit.length > 1) {
            if (position) position += ', ' + commit[1];
            else position = commit[1];
          }
        });

        window['dataLayer'].push({
          event: 'econfig_update',
          facet_category: category,
          facet_category_pos: position
        });
      }

      if (!dataItems.isManifoldProduct) {
        let cadCode = dataItems?.infoGroup?.cadCode?.value;
        setCadPartNumber(cadCode);
        let cadDetails = await getCADUrl(
          sessionDataItems?.manufacturingLocation,
          cadCode
        );

        var miscUrl =
          cadDetails.misc +
          '/service/reversemap?catalog=' +
          cadDetails.catalog +
          '&part=' +
          cadCode;
        let isValidCad = await isValidPartNumber(miscUrl, baseUrl);
        setIsValidCad(isValidCad);
        if (!isValidCad) {
          props.isLoading(false);
          return;
        }

        setPreviousPartNumber(currentPartNumber);
        setPreviousCadPartNumber(cadCode);
      } else {
        setCadPartNumber(getPartNumberString(dataItems));
        handleIsCADValueChanged(false);
      }
      await generateCadSrc();
      handleSetCommits('');
      props.isLoading(false);
    } catch (error) {
      props.isLoading(false);
    }
  };

  const getBomItems = assemblyCADXML => {
    const xmlDocument = new DOMParser().parseFromString(
      assemblyCADXML,
      'text/xml'
    );
    var bomMembers = [];
    var bomMember;

    var children = Array.from(
      xmlDocument.querySelectorAll('eConfigPart')[0].children
    );
    var sequence = 0;
    if (children.length > 0) {
      children.forEach(child => {
        if (child.nodeName == 'add_a_fold' || child.nodeName == 'station') {
          var subNodeChildren = Array.from(child.children);
          if (subNodeChildren.length > 0) {
            subNodeChildren.forEach(subChild => {
              if (subChild.nodeName == 'configured_part_no') {
                var attributes = Array.from(subChild.attributes);
                if (attributes.length > 0) {
                  attributes.forEach(attribute => {
                    if (attribute.nodeName == 'BomDesc') {
                      bomMember = initializeMember();
                      bomMember.description = attribute.value;
                      bomMember.value = subChild.textContent;
                      bomMembers.push(bomMember);
                    }
                  });
                }
              }

              if (subChild.nodeName == 'attributes') {
                var attributesChild = Array.from(subChild.children);
                if (attributesChild.length > 0) {
                  attributesChild.forEach(attribute => {
                    var attributesChildAttribute = Array.from(
                      attribute.attributes
                    );
                    if (attributesChildAttribute.length > 0) {
                      attributesChildAttribute.forEach(attributeChild => {
                        if (attributeChild.nodeName == 'BomDesc') {
                          bomMember = initializeMember();
                          bomMember.description = attributeChild.value;
                          bomMember.value = attribute.textContent;
                          bomMembers.push(bomMember);
                        }
                      });
                    }
                  });
                }
              }
            });
          }
        }
      });
    }

    var aggregateBOMMembers = [];
    var aggregateBOMMember;

    var sequence = 0;
    for (let member of bomMembers) {
      aggregateBOMMember = aggregateBOMMembers.find(
        x => x.description == member.description && x.value == member.value
      );
      if (aggregateBOMMember) {
        aggregateBOMMember.quantity = aggregateBOMMember.quantity + 1;
      } else {
        sequence = sequence + 1;
        aggregateBOMMember = initializeMember();
        aggregateBOMMember.description = member.description;
        aggregateBOMMember.value = member.value;
        aggregateBOMMember.quantity = 1;
        aggregateBOMMember.imageSequence = sequence;
        aggregateBOMMembers.push(aggregateBOMMember);
      }
    }

    var data = '';
    if (!aggregateBOMMembers || aggregateBOMMembers.length <= 0) return data;
    aggregateBOMMembers.forEach(member => {
      data += '<tr>';
      data += '<td>' + member.imageSequence + '</td>';
      data += '<td>' + member.quantity + '</td>';
      data += '<td>' + member.value + '</td>';
      data += '<td>' + member.description + '</td>';
      data += '</tr>';
    });

    return data;
  };

  const initializeMember = () => {
    return {
      name: '',
      description: '',
      value: '',
      valueDescription: '',
      quantity: 0,
      imageSequence: 0
    };
  };

  const isPTOSelector = () => {
    if (sessionDataItems?.configModel?.toLowerCase() == 'pto') return true;
    else return false;
  };

  const isMobile = () => {
    if (window.innerWidth < 768) return true;
    else return false;
  };

  const requiresCadUpdate = () => {
    console.log(
      `IS VALID CALL: current: ${currentPartNumber} - previous: ${previousPartNumber}`
    );
    if (dataItems.isManifoldProduct) {
      return isCADValueChanged;
    }

    return (
      currentPartNumber != previousPartNumber ||
      cadPartNumber != previousCadPartNumber
    );
  };

  return (
    <Grid container>
      <ModalCustom
        open={openModal}
        handleOpen={handleOpen}
        handleClose={handleClose}
        modalValue={modalValue}
        handleSubmit={handleSearchPartNumber}
      />
      <ModalLoad
        open={openLoadModal}
        handleOpen={handleLoadOpen}
        handleClose={handleLoadClose}
        modalValue={modalLoadValue}
        handleSubmit={handleSearchPartNumber}
        savedPartNumber={savedPartNumber}
      />
      {width > breakpoint && (
        <Grid item xs={12}>
          <Typography className="set-configuration-seriesname border-1">
            {isPTOSelector()
              ? 'Parker PTO Application Selector'
              : sessionDataItems?.seriesName}
          </Typography>
        </Grid>
      )}
      {showPartSection() && (
        <>
          {isPartnumberActions() && (
            <Grid item xs={12} className="part-section">
              <Grid item xs={6} className="configuration-code">
                {props.lang?.CONFIGURATION_CODE}
              </Grid>
              <Grid item xs={6} className="configuration-buttons">
                <CustomTooltip
                  title={props.lang?.CONFIG_CODE_SEARCH}
                  placement="top"
                >
                  <Grid
                    className="configuration-icon"
                    onClick={() =>
                      sethandleOpen(
                        props.lang?.CONFIG_CODE_SEARCH,
                        props.lang?.SEARCH,
                        props.lang?.ENTER_PART_NUMBER,
                        '',
                        'search',
                        {
                          isError: false,
                          message: props.lang?.NO_RESULTS_FOUND
                        }
                      )
                    }
                  >
                    <KeyboardAltOutlinedIcon className="font-size-14" />
                  </Grid>
                </CustomTooltip>
                <CustomTooltip
                  title={props.lang?.SHARE_CONFIGURATION}
                  placement="top"
                >
                  <Grid
                    className="configuration-icon"
                    onClick={() => {
                      sethandleOpen(
                        props.lang?.SHARE_CONFIGURATION,
                        props.lang?.SHARE,
                        props.lang?.ENTER_VALID_EMAIL,
                        '',
                        'share',
                        { isError: false, message: lang?.INVALID_EMAIL_ADDRESS }
                      );
                    }}
                  >
                    <FaShare className="font-size-14" />
                  </Grid>
                </CustomTooltip>
                <CustomTooltip
                  title={props.lang?.SAVE_CONFIGURATION}
                  placement="top"
                >
                  <Grid
                    className="configuration-icon"
                    onClick={() => handleSaveRequest()}
                  >
                    <SaveIcon className="font-size-14" />
                  </Grid>
                </CustomTooltip>
                <Grid
                  className={
                    savedPartNumber.length > 0
                      ? 'configuration-icon'
                      : 'configuration-icon-disable'
                  }
                  onClick={() => {
                    if (savedPartNumber.length > 0) {
                      sethandleLoadOpen(
                        lang?.LOAD_SAVED_CONFIGURATION,
                        lang?.LOAD,
                        lang?.DELETE,
                        lang?.CANCEL,
                        lang?.ENTER_CONFIG_NAME,
                        `${savedPartNumber}`,
                        'load',
                        { isError: false, message: '' }
                      );
                    }
                  }}
                >
                  <FaFolderOpen
                    className="font-size-14"
                    style={{
                      fill: savedPartNumber?.length > 0 ? '#000000' : '#6c757d'
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          {isPartNumberVisible() && (
            <Grid item xs={12} className="copy mt-1">
              <CustomTooltip
                title="Copied!"
                placement="top"
                open={tooltipIsOpen}
              >
                <Grid>
                  <span>
                    <FaCopy style={{ marginRight: '0.2rem' }} />
                  </span>
                </Grid>
              </CustomTooltip>
              <Grid>
                <Link
                  onClick={async () => await handleCopyPartNumber()}
                  className="copy-to-clipboard"
                >
                  {lang?.COPY_TO_CLIPBOARD}
                </Link>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            {isUniqueCodeAvailable() && (
              <div className="partNumberBox">{getUniquePartNumber()}</div>
            )}
          </Grid>

          <Grid item xs={12}>
            <PartNumberComponent startData={dataItems} />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <Typography className="normal-header mb-1">
          {lang?.PRODUCT_EXAMPLE}
        </Typography>
      </Grid>
      {isCADVisible() && baseUrl && (
        <Grid item xs={12} className="cad">
          {baseUrl?.source == 'PartSolutions' ||
          baseUrl?.source == '' ||
          baseUrl?.source == null ||
          baseUrl?.source == 'AutoCAD' ? (
            <>
              <div className="cad-preview">
                {cadPartNumberLoaded &&
                  (requiresCadUpdate() || !isValidCad) && (
                    <div className="loading-overlay">
                      <div className="loading-overlay-content">
                        {!isValidCad ? (
                          <span className="cad-invalid">
                            {lang?.PREVIEW_NOT_AVAILABLE}
                          </span>
                        ) : (
                          <RoundButton
                            classname="yellow-button w-auto"
                            name={lang?.UPDATE}
                            onClick={() => updatePreview()}
                          ></RoundButton>
                        )}
                      </div>
                    </div>
                  )}

                {cadPartNumberLoaded && (
                  <CAD
                    mident={mident}
                    translations={lang}
                    isManifoldProduct={dataItems?.isManifoldProduct}
                    sessionDataItems={sessionDataItems}
                    partNumberString={getPartNumberString(dataItems)}
                    catalog={catalog}
                    partNumber={cadPartNumber}
                    partSolutionsAPI={partSolutionsAPI}
                    bomItems={bomItems}
                    uniquePartIdentifier={uniquePartIdentifier}
                  />
                )}
              </div>
            </>
          ) : baseUrl?.source == 'Autodesk 360' ? (
            <div></div>
          ) : baseUrl?.source == 'ImageGrid' ? (
            <Grid container className="align-items-center">
              {possibleImages?.map(image => {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    key={image.componentName}
                  >
                    {image.imageSequence % 3 == 0 &&
                    image.imageUrl == 'NoImage' ? (
                      <div
                        style={{ maxWidth: '150px' }}
                        className="float-right"
                      >
                        <img
                          src="https://www.parker.com/content/dam/Parker-com/Images/eConfig/right-fitting-preview-not-available.jpg"
                          alt="Image preview not available"
                        />
                      </div>
                    ) : (image.imageSequence == 2 ||
                        (image.imageSequence - 2) % 3 == 0) &&
                      image.imageUrl == 'NoImage' ? (
                      <img
                        src="https://www.parker.com/content/dam/Parker-com/Images/eConfig/hose-preview-not-available.jpg"
                        alt="Image preview not available"
                      />
                    ) : (image.imageSequence == 1 ||
                        (image.imageSequence - 1) % 3 == 0) &&
                      image.imageUrl == 'NoImage' ? (
                      <div style={{ maxWidth: '150px !important' }}>
                        <img
                          src="'https://www.parker.com/content/dam/Parker-com/Images/eConfig/left-fitting-preview-not-available.jpg'"
                          alt="Image preview not available"
                        />
                      </div>
                    ) : image.imageSequence % 3 == 0 ? (
                      <div className="image-rotate">
                        <img
                          style={{ maxWidth: '100%', minHeight: '100%' }}
                          src={image.imageUrl}
                          onError={e => {
                            e.target.src =
                              'https://www.parker.com/content/dam/Parker-com/Images/eConfig/left-fitting-preview-not-available.jpg';
                          }}
                        />
                      </div>
                    ) : image.imageSequence == 2 ||
                      (image.imageSequence - 2) % 3 == 0 ? (
                      <div>
                        <img
                          style={{ maxWidth: '100%', minHeight: '100%' }}
                          src={image.imageUrl}
                          onError={e => {
                            e.target.src =
                              'https://www.parker.com/content/dam/Parker-com/Images/eConfig/hose-preview-not-available.jpg';
                          }}
                        />
                      </div>
                    ) : (
                      <div>
                        <img
                          style={{ maxWidth: '100%', minHeight: '100%' }}
                          src={image.imageUrl}
                          onError={e => {
                            e.target.src =
                              'https://www.parker.com/content/dam/Parker-com/Images/eConfig/left-fitting-preview-not-available.jpg';
                          }}
                        />
                      </div>
                    )}
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <img src={baseUrl?.url} style={{ maxWidth: '60%' }} />
          )}
        </Grid>
      )}
      {isMobile() && (
        <Grid item xs={12}>
          <RightSection
            contactus={props.contactus}
            dataItems={dataItems}
            sessionDataItems={sessionDataItems}
            lang={props.rightLang}
            isLoading={e => props.isLoading(e)}
            chk={1}
            priceLeadTime={priceLeadTime}
            hoseAssemblyPrice={hoseAssemblyPrice}
            handleUniquePartNumber={handleUniquePartNumber}
            uniquePartIdentifier={uniquePartIdentifier}
            activeTab={activeTab}
          />
        </Grid>
      )}
      {isProductDesc() && (
        <Grid item xs={12}>
          <hr />
          {isnotShop() && (
            <Typography className="normal-header mb-3">
              {lang?.PRODUCT_DESCRIPTION}
            </Typography>
          )}
          <>
            {isPTOSelector() ? (
              <div className="product-description">
                <p className="normal-header"> YOUR GUIDE TO CHELSEA PTOs </p>
                Configure the Chelsea PTO best suited for your transmission and
                application. Use this tool to build your part number. <br />
                <br /> Step 1: <br />
                <ul>
                  <li>
                    Identify the transmission make and model as well as desired
                    PTO opening.
                  </li>
                  <li>
                    Determine the type of PTO for the driven equipment:
                    Mechanical Shift, Power Shift, Constant Mesh, etc.
                  </li>
                  <li>
                    Select Min/Max of Engine % appropriate for the application.
                  </li>
                  <li>
                    Choose the configuration with the appropriate speed and
                    torque rating.
                  </li>
                  <li>
                    Select alternate mounting or assembly arrangement, if
                    desired.
                  </li>
                </ul>
                Have questions? Reach out to the Chelsea Technical Support Team
                at (662) 895-1011 or CHD_support@support.parker.com
                <br /> <br /> Step 2: <br />
                <ul>
                  <li>
                    Finalize your model configurations by selecting the Shift
                    Option and Output Option.
                  </li>
                </ul>
                To finish, click “View Summary Sheet” to print or save your
                configuration, including the part number, any required kits or
                accessories and important notes.
              </div>
            ) : (
              <div
                className="product-description"
                dangerouslySetInnerHTML={{ __html: productDiscription }}
              />
            )}
          </>
        </Grid>
      )}

      {isTechnicalSpec() && !isPTOSelector() && (
        <Grid item xs={12}>
          <hr />
          {isnotShop() && (
            <Typography className="normal-header mb-2">
              {lang?.PRODUCT_SERIES_GENERAL_SPECIFICATIONS}
            </Typography>
          )}

          <Grid container spacing={2}>
            {techSpecification ? (
              Object.entries(techSpecification)?.map(([key, value], index) => {
                return (
                  <Grid
                    item
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    key={index}
                    className="display-flex"
                  >
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className="normal-header"
                    >
                      {key}
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className="normal-text"
                    >
                      <div dangerouslySetInnerHTML={{ __html: value }} />
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      )}

      {hasSafetyWarning() &&
        isnotShop() &&
        isSafetyWarn() &&
        !isPTOSelector() && (
          <Grid
            item
            xs={12}
            className="mt-2 display-flex"
            onClick={() => {
              setOpenWarningModal(true);
            }}
          >
            <WarningAmberIcon className="safety-warning-icon" />
            <Grid>
              <a className="cursor-pointer safety-warning bold">
                Safety Warning
              </a>
            </Grid>
          </Grid>
        )}

      {isSupportDoc() && isnotShop() && !isPTOSelector() && (
        <Grid item xs={12}>
          <hr className="mt-1 mb-1" />
          <Typography className="normal-header">
            {lang?.SUPPORT_DOCUMENTS}
          </Typography>

          <Grid container>
            {supportDocs &&
              Object.entries(supportDocs)?.map(([key, documents], i) => {
                return (
                  <Grid item xs={12} key={key + '_' + i}>
                    <Typography className="support-doc-key">{key}</Typography>
                    {documents?.map((doc, index) => {
                      return (
                        <Grid
                          className="support-document"
                          key={doc.titleEN_t + '_' + index}
                        >
                          {doc.otAssetType_s.toUpperCase() == 'VIDEO' ? (
                            <a onClick={() => handleSupportModalClick(doc)}>
                              <FaVideo className="doc-icon" />
                              {doc?.titleEN_t}
                            </a>
                          ) : (
                            <a onClick={() => gotoPage(doc)}>
                              <BsFillFileEarmarkTextFill className="doc-icon" />
                              {doc?.titleEN_t}
                            </a>
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      )}

      <WarningModal
        open={openWarnigModal}
        handleClose={() => setOpenWarningModal(false)}
      />
      <VideoModal
        open={showVideoModal}
        videoUrl={videoUrl}
        handleClose={() => setShowVideoModal(false)}
      />
    </Grid>
  );
};
export default MiddleSection;
